export default __webpack_public_path__ + "static/media/thailand.15b7ab10.webp";